import { createSlice } from "@reduxjs/toolkit";
import { withAccessToken } from "../../server/api";
import { Chat } from "../api/chatApi";
import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_FINAN_DOMAIN;

const initialState = {
  token: null,
  userId: null,
  userInfo: {},
  userChatId: null,
  userChatInfo: null,
  isActiveUser: false,
  shopDomain: {},
  userChatBusinessId: null,
  idChatCurrent: null, // là id để truyền xuống chat (business || user)
};

const slice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    hasDone(state, action) {
      state.isLoading = false;
    },

    updateUserLoginId(state, action) {
      const { payload } = action;
      state.userId = payload;
    },
    updateUserLoginInfo(state, action) {
      const { payload } = action;
      state.userInfo = payload;
      state.userId = payload?.id;
    },
    updateToken(state, action) {
      const { payload } = action;
      state.token = payload;
    },

    updateActiveUserChat(state, action) {
      const { payload } = action;
      state.isActiveUser = payload;
    },
    getDomainSuccess(state, action) {
      const { payload } = action;
      state.shopDomain = payload;
    },

    setUserChatBusinessId(state, action) {
      const { payload } = action;
      state.userChatBusinessId = payload;
    },
    getShopSuccess(state, action) {
      const { payload } = action;

      const shopInfo = payload?.id ? payload : payload?.business

      const userInfo = {
        id: shopInfo?.creator_id,
        fullName: shopInfo?.name,
        avatar: shopInfo?.avatar,
        domain: shopInfo?.domain,
        business_id: shopInfo?.id,
      };
      state.userChatInfo = userInfo;
    },
    updateChatUserId(state, action) {
      const { payload } = action;
      state.userChatId = payload;
    },

    updateUserInfo(state, action) {
      const { payload } = action;
      state.userChatInfo = payload;
    },
    updateIdChatCurrent(state, action) {
      const { payload } = action;
      state.idChatCurrent = payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function receiveToken(token) {
  return (dispatch) => {
    dispatch(slice.actions.updateToken(token));
  };
}

export function getUserLoginId(userId) {
  return (dispatch) => {
    dispatch(slice.actions.updateUserLoginId(userId));
  };
}

export function setUserChatInfo(info) {
  return (dispatch) => {
    dispatch(slice.actions.updateUserInfo(info));
  };
}

export function setUserChatId(userId) {
  return (dispatch) => {
    dispatch(slice.actions.updateChatUserId(userId));
  };
}

export function getShopDomain(domain) {
  return (dispatch) => {
    dispatch(slice.actions.getDomainSuccess(domain));
  };
}
export function setUpdateIdChatCurrent(isChatCurrent) {
  return (dispatch) => {
    dispatch(slice.actions.updateIdChatCurrent(isChatCurrent));
  };
}

export function setUserChatBusinessId(userChatBusinessId) {
  return (dispatch) => {
    dispatch(slice.actions.setUserChatBusinessId(userChatBusinessId));
  };
}

export function getUserLoginInfo(domain) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const authConfig = await withAccessToken({});

      // `list_business` trong response của /auth/info hiện trả null cho
      // Shinhan store nên không thể lấy business_id từ đó. Gọi song song
      // /business/get-info-public với domain (truyền từ URL) để có business_id.
      const [authResponse, shopResponse] = await Promise.all([
        Chat.authUser({ headers: authConfig }),
        domain
          ? Chat.getShopInfo({
              params: { domain },
              headers: await withAccessToken({
                "Content-Type": "application/json;charset=UTF-8",
              }),
            })
          : Promise.resolve(null),
      ]);

      const userInfo = authResponse?.data?.user_info;
      const businessRequest = authResponse?.data?.list_business?.find(
        (value) => value.status === "requested"
      );

      const shopData = shopResponse?.data;
      const shopPayload = Array.isArray(shopData) ? shopData[0] : shopData;
      const shopBusiness = shopPayload?.id
        ? shopPayload
        : shopPayload?.business;

      if (shopPayload) {
        dispatch(slice.actions.getShopSuccess(shopPayload));
      }

      const resolvedDomain =
        businessRequest?.domain || shopBusiness?.domain || domain || "";
      const resolvedBusinessId =
        businessRequest?.id || shopBusiness?.id || "";

      const data = {
        fullName: userInfo?.full_name,
        avatar: userInfo?.avatar,
        domain: resolvedDomain,
        is_anonymous: userInfo?.is_anonymous,
        business_id: resolvedBusinessId,
        id: userInfo?.id,
      };
      dispatch(slice.actions.updateUserLoginInfo(data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}

export function getActiveUserChat(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = await withAccessToken({
        "Content-Type": "application/json;charset=UTF-8",
      });
      const response = await Chat.getActiveUserChat(
        {
          headers: config,
        },
        id
      );

      dispatch(
        slice.actions.updateActiveUserChat(response.data?.is_online || false)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}

export function getShopInfo(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = await withAccessToken({
        "Content-Type": "application/json;charset=UTF-8",
      });

      const response = await Chat.getShopInfo({
        params: params,
        headers: config,
      });
      const data = response?.data;
      const payload = Array.isArray(data) ? data[0] : data;
      if (payload?.id || payload?.business?.id) {
        dispatch(slice.actions.getShopSuccess(payload));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}
